import { useCallback } from 'react';

import postMessageHelper from 'Util/Message/postMessageHelper';
import { TOPIC } from 'Util/Message/TopicName';

import useTracking from './useTracking';

const CATEGORY = 'Notification';

const NOTIFICATION_ACTIONS = {
  OPEN: 'Open notification panel',
  ITEM_CLICK: 'Clicked on notification item',
  TAB_CLICK: 'Select tab',
};

export const genNotificationClickEvent = (action, label) => ({
  category: CATEGORY,
  action: NOTIFICATION_ACTIONS.OPEN,
});

export const genNotificationItemClickEvent = (label) => ({
  category: CATEGORY,
  action: NOTIFICATION_ACTIONS.ITEM_CLICK,
  label,
});

export const genNotificationTabClickEvent = (label) => ({
  category: CATEGORY,
  action: NOTIFICATION_ACTIONS.TAB_CLICK,
  label,
});

function useNotificationTracking() {
  const { logAction } = useTracking();

  const logNotificationClick = useCallback(() => {
    logAction(genNotificationClickEvent());
    postMessageHelper(TOPIC.NOTIFICATION_CLICKED);
  }, [logAction]);

  const logNotificationItemClick = useCallback(
    (notificationTitle) => {
      logAction(genNotificationItemClickEvent(notificationTitle));
      postMessageHelper(TOPIC.NOTIFICATION_ITEM_CLICKED, { notificationTitle });
    },
    [logAction]
  );

  const logNotificationTabClickEvent = useCallback(
    (tabTitle) => {
      logAction(genNotificationTabClickEvent(tabTitle));
      postMessageHelper(TOPIC.NOTIFICATION_TAB_CLICKED, { tabTitle });
    },
    [logAction]
  );

  return { logNotificationClick, logNotificationItemClick, logNotificationTabClickEvent };
}

export { useNotificationTracking };
